// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1xrw2","list":"styles_list__3rBgu"};